import { AxiosResponse } from 'axios';
import configuration from 'config';
import OfertaRegistroModel, { OfertaRegistroAPI } from 'types/models/OfertasServiceNuevoOnboarding';
import apiService from './ApiService';

export class OfertasService {
  readonly http = apiService;

  private apiUrl = configuration.apiUrl;

  async getOfertasBySolicitud(solicitudId: string): Promise<OfertaRegistroAPI[]> {
    const url = `${this.apiUrl}/onboarding/solicitud-de-registro/${solicitudId}/ofertas/`;
    const response: AxiosResponse = await this.http.get(url);
    const result = new OfertaRegistroModel().deserializeArray(response.data);
    return result;
  }

  async createOferta(solicitudId: string, data: Partial<OfertaRegistroAPI>): Promise<OfertaRegistroAPI> {
    const url = `${this.apiUrl}/onboarding/solicitud-de-registro/${solicitudId}/ofertas/`;
    const response: AxiosResponse<OfertaRegistroAPI> = await this.http.post(url, data);
    return response.data;
  }

  async getOfertaById(solicitudId: string, ofertaId: string): Promise<OfertaRegistroAPI> {
    const url = `${this.apiUrl}/onboarding/solicitud-de-registro/${solicitudId}/ofertas/${ofertaId}/`;
    const response: AxiosResponse<OfertaRegistroAPI> = await this.http.get(url);
    return response.data;
  }

  async updateOferta(
    solicitudId: string,
    ofertaId: string,
    data: Partial<OfertaRegistroAPI>,
  ): Promise<OfertaRegistroAPI> {
    const url = `${this.apiUrl}/onboarding/solicitud-de-registro/${solicitudId}/ofertas/${ofertaId}/`;
    const response: AxiosResponse<OfertaRegistroAPI> = await this.http.put(url, data);
    return response.data;
  }

  async deleteOferta(solicitudId: string, ofertaId: string): Promise<number> {
    const url = `${this.apiUrl}/onboarding/solicitud-de-registro/${solicitudId}/ofertas/${ofertaId}/`;
    const response: AxiosResponse<{ status: number }> = await this.http.delete(url);
    return response.data.status;
  }
}

const ofertasService = new OfertasService();
export default ofertasService;
